import React from 'react';

const LabelChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M4.5 18.5v-13h11.2l4.6 6.5-4.6 6.5H4.5zm1-1h9.7l3.9-5.5-3.9-5.5H5.5v11z"
            fill="#fff"
        />
        <path d="M5 6v12h10.5H5V6m11-1H4v14h12l5-7-5-7zM6 17V7h9l3.6 5-3.6 5H6z" />
    </svg>
);

LabelChunkySvg.displayName = 'LabelChunkySvg';
export default LabelChunkySvg;
